var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCellphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.462,
    height: 44.612,
    viewBox: "0 0 25.462 44.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cellphone-svgrepo-com",
    d: "M26.444,4.693V43.059a3.131,3.131,0,0,1-3.123,3.123H4.1A3.131,3.131,0,0,1,.982,43.059V4.693A3.131,3.131,0,0,1,4.1,1.57H23.321A3.131,3.131,0,0,1,26.444,4.693ZM23.321,9.834H4.1V38.4H23.321ZM8.516,5.881a1.561,1.561,0,0,0,1.561,1.561h7.277a1.561,1.561,0,1,0,0-3.123H10.077A1.561,1.561,0,0,0,8.516,5.881Zm6.756,36.411a1.556,1.556,0,1,0-.457,1.1A1.556,1.556,0,0,0,15.272,42.292Z",
    transform: "translate(-0.982 -1.57)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.4fb30d347954845bcaa5ebf21c1c2879.svg";
export { ForwardRef as ReactComponent };